enum AdminToolType {
	IDE = '1',
	ConfigurationManager = '2',
	Security = '3',
	MenuDesigner = '4',
	LogViewer = '5',
	IndexReport = '6',
	TaskManagement = '7',
	DataSecurity = '8',
	LicenceManagement = '9'
}
export default AdminToolType;
